import { moeda } from "../lib/formato";
import { serveAoBloco } from "../lib/periodoValor";
import type { PeriodoValor, TabelaValor, TipoTabelaValor } from "../lib/tipos";

/**
 * Select alimentado pela tabela de valores. Filtra pelo curso escolhido, do mesmo
 * jeito que o 4.x: mostra o valor se ele não tem curso ou se bate com o selecionado.
 *
 * Quando `periodo` é informado, filtra também pelo turno — é o que impede o
 * bloco do integral de oferecer as mensalidades parciais e vice-versa.
 */
export function CampoValor({
  rotulo,
  tipo,
  periodo,
  valores,
  cursoId,
  valor,
  onChange,
  opcaoZero,
  avisoVazio,
}: {
  rotulo: string;
  tipo: TipoTabelaValor;
  /** Só para MENSALIDADE: restringe às linhas daquele turno. */
  periodo?: PeriodoValor;
  valores: TabelaValor[];
  cursoId: string;
  valor: string;
  onChange: (v: string) => void;
  opcaoZero?: string;
  avisoVazio: string;
}) {
  const doTipo = valores.filter((v) => v.tipo === tipo && (!periodo || serveAoBloco(v, periodo)));
  const disponiveis = doTipo.filter((v) => !v.curso || !cursoId || v.curso.id === cursoId);

  return (
    <div style={{ flex: "1 1 48%", minWidth: 220 }}>
      <label className="rotulo">{rotulo}</label>
      <select className="campo" value={valor} onChange={(e) => onChange(e.target.value)}>
        <option value="">Selecione um valor...</option>
        {opcaoZero && <option value="0">{opcaoZero}</option>}
        {disponiveis.map((v) => (
          <option key={v.id} value={v.valor}>
            {moeda(v.valor)}
            {v.descricao ? ` — ${v.descricao}` : ""}
            {v.curso ? ` (${v.curso.nome})` : ""}
          </option>
        ))}
      </select>
      {doTipo.length === 0 && (
        <div style={{ fontSize: 11, color: "#d92d20", marginTop: 4 }}>{avisoVazio}</div>
      )}
    </div>
  );
}
